import { defineStore } from "pinia";

export const useFormsStore = defineStore("forms", {
  state: () => ({
    activeForm: null,
    formData: null,
    type: "",
    item: {},
    open: false,
    options: {},
  }),

  actions: {
    setActiveForm(form) {
      this.activeForm = form;
    },
    setFormData(data) {
      this.formData = data;
    },
    // reset() {
    //   // Use batch update to minimize reactive triggers
    //   this.$patch({
    //     activeForm: null,
    //     formData: null,
    //     type: "",
    //     item: {},
    //     open: false,
    //     options: {},
    //   });
    // },
    edit({ type, item, options = {} }) {
      // Use batch update to minimize reactive triggers
      console.log("FormsStore: BT Editing form", {
        type,
        item,
        options,
      });
      this.$patch({
        type,
        item: { ...item },
        open: true,
        options,
      });
    },
    async submit(form) {
      try {
        this.reset();
        return form;
      } catch (error) {
        console.error("Error submitting form:", error);
        throw error;
      }
    },
  },
});
